export default __webpack_public_path__ + "static/media/955.0c18ace8.png";